<template>
  <img width="24" height="24" :src="active ? require('../image/thumbs-up-green.png') : require('../image/thumbs-up.png')" :class="['item-icon', { 'is-disabled': disabled }]" />
</template>

<script>
export default {
  name: 'ThumbsUpIcon',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.item-icon {
  cursor: pointer;
  transition: transform 0.2s ease;
}
.item-icon:hover {
  transform: scale(1.2);
}
.item-icon.is-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>